export const STORE_KEYS = {
  SELECTED_STANDORT_ID: "admin.selectedStandortId",
  RA_STORE_PREFIX: "RaStore",
} as const;

export const ALL_STANDORT_VALUE = "__all__";

export type StoredStandort = string | { id: string; name: string; organizationId: string };

export const ROWS_PER_PAGE = 50;
